module.exports = __webpack_public_path__ + "img/tnc.071f900c.svg";